import { useEffect, useState } from "react";

import { install } from "resize-observer";

import { HOUSEHOLD_PROFILE } from "./drawerKeys";

const useWidth = ({ drawerKey }) => {
  const [profileWidth, setProfileWidth] = useState(0);

  useEffect(() => {
    if (drawerKey !== HOUSEHOLD_PROFILE) return;
    if (!window.ResizeObserver) install();

    let resizeObserver;
    let mutationObserver;

    const observe = (node) => {
      resizeObserver = new ResizeObserver(() => {
        setProfileWidth(node.clientWidth || 0);
      });
      resizeObserver.observe(node);
    };

    // Try to find the element immediately
    const node = document.querySelector(".user_profile_wrapper");
    if (node) {
      observe(node);
    } else {
      // Wait for the element to appear (e.g. after Suspense resolves)
      mutationObserver = new MutationObserver(() => {
        const found = document.querySelector(".user_profile_wrapper");
        if (found) {
          mutationObserver.disconnect();
          observe(found);
        }
      });
      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    return () => {
      resizeObserver?.disconnect();
      mutationObserver?.disconnect();
    };
  }, [drawerKey]);

  if (drawerKey === HOUSEHOLD_PROFILE) {
    return Math.max(720, profileWidth + 80);
  }

  return 400;
};

export { useWidth };
